import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from 'react-redux';

import Admin from "./pages/setup";

import HasRole from "src/utils/has-role";
import GroupMenu from "src/components/group-menu";
import GroupContainer from "src/components/group-container";

import { CogIcon } from "@heroicons/react/24/outline";

export const getRoutes = (account) => [
  { name: 'Fraud Shield Configuration', description: 'View and manage your fraud shield configuration', path: '/shield/admin', check: HasRole(account, ['booking-and-payment:organisation-access']) },
];

const Layout = ({ children }) => {
  const { account: { account } } = useSelector((state) => state);

  const items = [
    { name: 'Fraud Shield Configuration', description: 'View and manage your fraud shield configuration', icon: CogIcon, path: '/shield/admin', check: HasRole(account, ['booking-and-payment:organisation-access']) },
  ];

  return (
    <div id="content">
      <GroupMenu items={items} title="Shield" />
      <GroupContainer>
        {children}
      </GroupContainer>
    </div>
  )
};

const BasePathRenderer = () => {
  const { account: { account } } = useSelector((state) => state);

  let path = '/';

  if (HasRole(account, ['booking-and-payment:organisation-access'])) {
    path = `/shield/admin`;
  }

  return (
    <Route exact path="/shield" component={(props) => {
      return (
        <Redirect to={path} />
      )
    }}
    />
  );
};

const ShieldRouter = () => {
  const { account: { account } } = useSelector((state) => state);

  if (account?.id) {
    return (
      <React.Fragment>

        {BasePathRenderer()}

        {HasRole(account, ['booking-and-payment:organisation-access']) && (
          <Route exact path={`/shield/admin`} component={() => <Layout><Admin /></Layout>} />
        )}

      </React.Fragment>
    );
  }

  return <React.Fragment />;
};

export default ShieldRouter;
